import { Box, BoxProps, ColorOptions, ModBox, Spacer, SpacerNew, Text } from '@jfs/ui-new'
import { hyphenSplashSeparatedDate } from '@jfs/utils'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import { Pressable, ScrollView, View } from 'react-native'
import { ShimmerView } from '../../comps/ShimmerView'
import { SvgImage } from '../../comps/SvgImage'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { hyphenSeparatedDate } from '../../util/billPaymentUtil'
import { PoweredBy } from './Footer/PoweredBy'
import { RecentTransactions } from './RecentTransactions'
import { RenderCategory } from './RenderCategory'
import { RenderHeader } from './RenderHeader'
import { SearchBar } from './SearchBar'

const HederComp = ({ navigation }: any) => {
  return (
    <Box flexDirection={'row'} align="center" pr={25}>
      <View>
        <Pressable
          testID="support-icon"
          onPress={() => navigation?.navigate(Routes.SUPPORT as never, { header: 'Help & Support' } as never)}>
          <SvgImage imageName="SupportIcon" color={'#fff'} />
        </Pressable>
      </View>
      <Spacer size={10} direction="horizontal" />
    </Box>
  )
}

const BillPayments = () => {
  const { getCategoryListV2, getOrderHistoryApi, updateTransactionOrder, getCategoryList, getCategoryBySearchText } =
    useStores((root) => ({
      getCategoryListV2: root.billPayments.getCategoryApiV2,
      getOrderHistoryApi: root.billPayments.getOrderHistoryApi,
      updateTransactionOrder: root.billPayments.updateTransactionOrder,
      getCategoryList: root.billPayments.getCategoryList,
      getCategoryBySearchText: root.billPayments.getCategoryBySearchText,
    }))
  const [getCategoryApiV2, { state: categoryLoadingV2 }] = useLazyApiData(getCategoryListV2)
  const [orderHistoryApi, { state: orderHistoryState, data: orderHistoryData }] = useLazyApiData(getOrderHistoryApi)

  const navigation = useNavigation()
  const [searchText, setSearchText] = useState('')
  const [showNoResults, setShowNoResults] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [orderHistoryDataSet, setOrderHistoryDataSet] = useState([])
  const [categoryList, setCategoryList]: any = useState([])
  const [categoryStoreData, setCategoryStore] = useState([])

  useEffect(() => {
    navigation.setOptions({
      gestureEnabled: true,
      headerRight: () => <HederComp navigation={navigation} />,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const isFocused = useIsFocused()

  useEffect(() => {
    if (isFocused) {
      getCategoryApiV2()
      orderHistoryApi(startDate, endDate)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused])

  useEffect(() => {
    if (categoryLoadingV2 === 'rejected' || categoryLoadingV2 === 'fulfilled') {
      const categoryData = getCategoryList()
      setCategoryList(categoryData)
      setCategoryStore(categoryData)
      setIsLoading(false)
    }
  }, [categoryLoadingV2, getCategoryList])

  useEffect(() => {
    if (orderHistoryState === 'fulfilled') {
      if (Array.isArray(orderHistoryData)) {
        setOrderHistoryDataSet(orderHistoryData)
      }
    } else if (orderHistoryState === 'rejected') {
      console.log('No order history found')
      setOrderHistoryDataSet([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderHistoryData])

  const startDate = ((sd: Date) => {
    const sDate = new Date(sd.getFullYear(), sd.getMonth(), sd.getDate() - 7, 0, 0, 0)
    return hyphenSplashSeparatedDate(sDate, 'yyyy-MM-dd hh:mm:ss').replace(' ', 'T')
  })(new Date())

  const endDate = ((sd: Date) => {
    const eDate = new Date(sd)
    return hyphenSplashSeparatedDate(eDate, 'yyyy-MM-dd hh:mm:ss').replace(' ', 'T')
  })(new Date())

  const onChangeText = async (text: string) => {
    await setSearchText(text)
    if (text?.length > 0) {
      const searchString = text?.toLowerCase()

      const result = await getCategoryBySearchText(categoryStoreData, searchString)
      setCategoryList(result ?? [])
      setShowNoResults(result?.length ? false : true)
    } else {
      setCategoryList(categoryStoreData)
      setShowNoResults(false)
    }
  }

  const refreshOrderHistory = () => {
    orderHistoryApi(startDate, endDate)
  }

  // const renderBills = () => {
  //   if (categoryLoadingV2 === 'rejected') {
  //     return null
  //   }
  //   return <MyBillsNew setIsLoading={setIsLoading} />
  // }

  const loadMore = () => {
    navigation.navigate(Routes.BILL_PAYMENTS_TRANSACTIONS as never, { tittle: 'All Transactions' } as never)
  }

  const onSelect = (txn: any) => {
    updateTransactionOrder({
      ...txn,
      shortName: txn.product.name,
      timeStamp: hyphenSeparatedDate(new Date(txn?.payment?.paymentAt), 'dd-mm-yyyy hh:mm:ss'),
    })
    // navigate to transaction detail screen
    navigation.navigate(Routes.BILL_PAYMENTS_TRANSACTIONS_DETAILS as never, { data: txn } as never)
  }

  return (
    <Box flex={1} backgroundColor="SECONDARY" position={'relative'} pt={70}>
      <ModBox {...styles.listWrapper} backgroundColor={'WHITE'} pb={0}>
        <Box pt={8} ph={24} backgroundColor={'WHITE'}>
          <SearchBar
            onChange={onChangeText}
            placeholder="Search by category or operator"
            value={searchText}
            borderRadius={8}
            theme={{ bodyBgColor: '#fff', bodyTextColor: '#B5B5B5' as ColorOptions }}
          />

          <SpacerNew size={2} direction="vertical" />
        </Box>
        <ScrollView
          contentContainerStyle={{ flexGrow: 1 }}
          showsVerticalScrollIndicator={false}>
          {/* No results found */}
          <ModBox mt={8} ph={24} show={showNoResults} flex={1}>
            <Text fontSize={14} lineHeight={18} color="PRIMARY_GREY" fontFamily="JioType-Medium">
              No search results found for{' - '}
              <Text fontSize={14} color="BLACK_21" fontFamily="JioType-Black">
                {searchText}
              </Text>
            </Text>
          </ModBox>

          <SpacerNew size={20} direction="vertical" />
          <RenderCategory categoryList={categoryList} />
          <SpacerNew size={32} direction="vertical" />

          {isLoading && (
            <Box ph={24}>
              <ShimmerView type={Routes.TRANSACTIONS} itemCount={2} />
            </Box>
          )}
          {orderHistoryState === 'pending' && (
            <Box ph={24}>
              <ShimmerView type={Routes.TRANSACTIONS} itemCount={2} />
            </Box>
          )}
          <ModBox
            ph={24}
            show={!searchText?.length && orderHistoryState !== 'pending' && orderHistoryDataSet?.length > 0}>
            <RenderHeader title="Recent Transactions" />
            <SpacerNew size={10} direction="vertical" />
            <RecentTransactions
              api={refreshOrderHistory}
              data={orderHistoryDataSet}
              state={orderHistoryState}
              apiError={orderHistoryData}
              onSelect={onSelect}
            />

            <SpacerNew size={20} direction="vertical" />
            <ModBox justifyContent={'center'} alignItems="center">
              <Box {...styles.loadMore} testID="view-all-txn" onPress={loadMore} underlayColor={'TRANSPARENT'}>
                <Text color={'PRIMARY'} fontFamily={'JioType-Bold'} fontSize={12}>
                  View all transactions
                </Text>
              </Box>
            </ModBox>
          </ModBox>
        </ScrollView>
        <SpacerNew size={20} direction="vertical" />
      </ModBox>
      <Box bg={'WHITE'}>
        <PoweredBy />
      </Box>
    </Box>
  )
}
const styles = {
  listWrapper: {
    flex: 1,
    backgroundColor: 'WHITE',
    paddingVertical: 24,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    width: '100%',
    zIndex: 4,
    overflow: 'auto',
  } as BoxProps,
  loadMore: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    backgroundColor: 'WHITE' as ColorOptions,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 15,
    flexDirection: 'row',
    borderColor: 'PRIMARY',
    borderWidth: 1,
  } as BoxProps,
}
export default BillPayments
